/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useCallback } from "react";
import moment from "moment";
import { azureFetch } from "../../api/azureFetch";

function useLogReport(page) {

    const logReport = useCallback((action) => {
        azureFetch("create-user-login-history", {
                eventTime: moment().format("YYYY-MM-DDTHH:mm:ss"),
                page: page,
                action: action,
        })
    }, []);

    useEffect(() => {
        logReport('ENTER');
    }, [logReport]);
}


export default useLogReport;